import type { ComponentProps } from "react"
import { Suspense } from "react"
import { markdownClassName } from "./markdown.css"
import { Box, Pulse } from "@sembark-travel/ui-base"
import { ErrorBoundary } from "@sembark-travel/ui-error-boundary"
import ReactMarkdown from "react-markdown"
import remarkGithubFlavouredMarkdown from "remark-gfm"
import { remarkMark } from "remark-mark-highlight"

export function Markdown({
	children,
	className,
	...props
}: ComponentProps<typeof ReactMarkdown> & { className?: string }) {
	return (
		<ErrorBoundary>
			<Suspense
				fallback={
					<Pulse className={markdownClassName} whiteSpace="preserveAndWrap">
						{children}
					</Pulse>
				}
			>
				<Box className={`${markdownClassName} ${className || ""}`}>
					<ReactMarkdown
						remarkPlugins={[remarkGithubFlavouredMarkdown, remarkMark]}
						{...props}
					>
						{children}
					</ReactMarkdown>
				</Box>
			</Suspense>
		</ErrorBoundary>
	)
}
